/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Import custom components and assets*/
// import Notifications from '../../container/notification/notification.js';

class Topbar extends Component {
  constructor(props){
    super(props);
    this.state = {
       activeItem: ""

    }
  }
  componentDidMount() {
    this.findActiveItem();
    // alert("hiii");

  }
  logout() {
    localStorage.clear();
    window.location.href = '/';
  }
  findActiveItem(){
    var tempUrl = [];
    tempUrl = window.location.href.split("/");
    this.setState({activeItem: tempUrl[tempUrl.length-1]});
    // console.log(tempUrl[tempUrl.length-1]);
  }

  navItemClick(item){
    this.setState({activeItem: item});
  }

  render() {
    return (
      <header className="text-right">
        {
          this.state.activeItem == "notification" ?
            <Link className="e-notification e-active" onClick={this.navItemClick.bind(this, "notification")} to="/notification"></Link>
              :
            <Link className="e-notification" onClick={this.navItemClick.bind(this, "notification")} to="/notification"></Link>
        }

        <span className="e-logout" onClick={this.logout.bind(this)}>Logout</span>
      </header>
    );
  }
}

export default Topbar;
